var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"nav-main yamm navbar",attrs:{"id":"main-navigation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }